import React, { useEffect, useState } from 'react';
import { ArrowContainer, Popover } from 'react-tiny-popover';
import Select from 'react-select';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';

import {
  firstPartDayHour,
  secondPartDayHour,
  slotIsAvailable,
  thirdPartDayHour,
  getSlotHour,
  morningSlotValue,
  afternoonSlotValue,
  eveningSlotValue,
} from '../../util/dates';
import { Button, IconClose } from '../../components';

import css from './Day.css';

const Day = props => {
  const {
    dateModifiers,
    date,
    isSelected,
    isInSelection,
    isEndDate,
    timeSlots,
    startDate,
    endDate,
    setStartHour,
    setEndHour,
    handleAvailability,
    intl,
  } = props;
  const [isPopoverOpen, setIsPopoverOpen] = useState(isEndDate);
  const morningText = intl.formatMessage({ id: 'ManageAvailabilityCalendar.morning'});
  const afternoonText = intl.formatMessage({ id: 'ManageAvailabilityCalendar.afternoon'});
  const eveningText = intl.formatMessage({ id: 'ManageAvailabilityCalendar.evening'});
  const [selectedStartSlot, setSelectedStartSlot] = useState({ value: morningSlotValue, label: morningText });
  const [selectedEndSlot, setSelectedEndSlot] = useState({ value: eveningSlotValue, label: eveningText });
  const { isOutsideRange, isSameDay } = dateModifiers(date);

  useEffect(() => {
    setIsPopoverOpen(isEndDate);
  }, [isEndDate]);

  const onEndDateClick = () => {
    setIsPopoverOpen(true);
  };
  const handleClose = () => {
    setIsPopoverOpen(false);
  };
  const handleSlotStart = (slotSelected) => {
    const isStart = true;
    const startHour = getSlotHour(slotSelected.value, isStart);
    setSelectedStartSlot(slotSelected);
    setStartHour(startHour);
  };
  const handleSlotEnd = (slotSelected) => {
    const endHour = getSlotHour(slotSelected.value);
    setSelectedEndSlot(slotSelected);
    setEndHour(endHour);
  };

  const morningSlotAvailable = slotIsAvailable(date, firstPartDayHour, timeSlots);
  const afternoonSlotAvailable = slotIsAvailable(date, secondPartDayHour, timeSlots);
  const eveningSlotAvailable = slotIsAvailable(date, thirdPartDayHour, timeSlots);
  const morningSlotClasses = classNames(css.slotBlocked, { [css.slotAvailable]: morningSlotAvailable });
  const afternoonSlotClasses = classNames(css.slotBlocked, { [css.slotAvailable]: afternoonSlotAvailable });
  const eveningSlotClasses = classNames(css.slotBlocked, { [css.slotAvailable]: eveningSlotAvailable });

  const availableText = intl.formatMessage({ id: 'ManageAvailabilityCalendar.availableDay' });
  const unavailableText = intl.formatMessage({ id: 'ManageAvailabilityCalendar.blockedDay' });
  const closeModalMessage = intl.formatMessage({ id: 'Modal.closeModal' });
  
  const selectSlotOptions = [
    { value: morningSlotValue, label: morningText },
    { value: afternoonSlotValue, label: afternoonText },
    { value: eveningSlotValue, label: eveningText },
  ];

  const popoverContent = ({ position, childRect, popoverRect }) => (
    <ArrowContainer
      position={position}
      childRect={childRect}
      popoverRect={popoverRect}
      arrowColor={'white'}
      arrowSize={12}
    >
      <div className={css.popoverContainer}>
        <Button
          onClick={handleClose}
          rootClassName={css.close}
          title={closeModalMessage}
        >
          <span className={css.closeText}>
            <FormattedMessage id="Modal.close" />
          </span>
          <IconClose rootClassName={css.closeIcon} />
        </Button>
        <div className={css.startContainer}>
          <span>{startDate && startDate.format('D MMMM YYYY')}</span>
          <Select
            className={css.selectSlot}
            classNamePrefix={'selectSlot'}
            value={selectedStartSlot}
            onChange={handleSlotStart}
            options={selectSlotOptions}
            isSearchable={false}
          />
        </div>
        <div className={css.endContainer}>
          <span>{endDate && endDate.format('D MMMM YYYY')}</span>
          <Select
            className={css.selectSlot}
            classNamePrefix={'selectSlot'}
            value={selectedEndSlot}
            onChange={handleSlotEnd}
            options={selectSlotOptions}
            isSearchable={false}
          />
        </div>
        <div className={css.buttonContainer}>
          <Button className={css.available} onClick={handleAvailability(true)}>{availableText}</Button>
          <Button className={css.unavailable} onClick={handleAvailability(false)}>{unavailableText}</Button>
        </div>
      </div>
    </ArrowContainer>
  );

  const dayClasses = classNames(css.default, {
    [css.outsideRange]: isOutsideRange,
    [css.today]: isSameDay,
    [css.isSelected]: isSelected,
    [css.isInSelection]: isInSelection,
  });

  return (
    <div className={css.dayWrapper}>
      {!isOutsideRange && !isEndDate ? (
        <div className={dayClasses}>
          <span className={css.dayNumber}>{date.format('D')}</span>
          <div className={css.availabilityContainer}>
            <div className={morningSlotClasses} />
            <div className={afternoonSlotClasses} />
            <div className={eveningSlotClasses} />
          </div>
        </div>
      ) : null}
      {isOutsideRange ? (
        <div className={dayClasses}>
          <span className={css.dayNumber}>{date.format('D')}</span>
        </div>
      ) : null}
      {isEndDate && !isOutsideRange ? (
        <Popover
          isOpen={isPopoverOpen}
          positions={['top', 'bottom', 'left', 'right']}
          content={popoverContent}
        >
          <div className={dayClasses} onClick={onEndDateClick}>
            <span className={css.dayNumber}>{date.format('D')}</span>
            <div className={css.availabilityContainer}>
              <div className={morningSlotClasses} />
              <div className={afternoonSlotClasses} />
              <div className={eveningSlotClasses} />
            </div>
          </div>
        </Popover>
      ) : null}
    </div>
  );
}

export default Day;


// WEBPACK FOOTER //
// ./src/components/ManageAvailabilityCalendar/Day.js